
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const accountService = createApi({
  reducerPath: "accountMasterService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["accountMaster"],
  endpoints: (builder) => ({
    getAllAccountWithPagination: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountMasterController.getAllAccountWithPagination}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}`},
          // body: body.payload,
        };
      },
    }),
    getAllAccountWithSearch: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountMasterController.getAllAccountWithSearch}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    updateAccount: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountMasterController.updateAccount}/${body.id}`,
          method: "PUT",
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    deleteAccountById: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountMasterController.deleteAccountById}/${body.id}`,
          method: "DELETE",
          headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    getAccountById: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountMasterController.getAccountById}/${body.id}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    saveAccount: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountMasterController.saveAccount}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    getAllAccount: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountMasterController.getAllAccount}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    bulkSaveAccount: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountMasterController.bulkSaveAccount}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
  }),
});
export const {
  useSaveAccountMutation,
  useUpdateAccountMutation,
  useBulkSaveAccountMutation,
  useDeleteAccountByIdMutation,
  useGetAccountByIdMutation,
  useGetAllAccountMutation,
  useGetAllAccountWithPaginationMutation,
  useGetAllAccountWithSearchMutation
} = accountService;
